import React, { useEffect } from 'react'
import Sidebar from '../Components/Sidebar'
import Topbar from '../Components/Topbar'
// import { useSelector, useDispatch } from 'react-redux';
import axiosJWT from '../../secureAPI/axiosJWT';
import { validateImageFile } from '../../Utils/validateFile';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import PencilIcon from '../Components/PencilIcon';
import ProfilePicModal from '../Components/ProfilePicModal';
import MidDashboard from '../../middleware/Dashboard/MidDashboard';
import OrdersPieChart from '../Components/OrderPieChart';
import OrdersChart from '../Components/OrdersChart';
import ProgressBar from '../Components/ProgressBar';
import { useState, useParams, useRef, FiHome, Indiacirclelogo, moment, FaInfo, Tippy, BsCart3, TbUsers, FaUserTie, BiMessageAltError, Link, Check, BsArrowRightShort, noUser, overlayStyle, loaderStyle } from '../../common/common';
// import MobileMenu from '../Components/MobileMenu';

const Dashboard = () => {
    const { type } = useParams();

    const { users, userPlan, orders, isLoading, setisLoading, setisDisabled, planDetails, buyerOrders } = MidDashboard(type);
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const avatarUrl = useRef('/assets/images/noPreview.png');
    const [modalOpen, setModalOpen] = useState(false);
    const [profilepic, setProfilepic] = useState(`${process.env.REACT_APP_API_URL}/assets/images/noUser.png`);
    // console.log({ user: users });
    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var UserProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var usertypeArray = usertype.split(',').map(Number);
        var hasOne = usertypeArray.includes(1);
        var hasTwo = usertypeArray.includes(2);
        var hasOneAndTwo = [1, 2].every(num => usertypeArray.includes(num));
        var username = users[0]['FullName'];
        var CompanyName = users[0]['CompanyDetails']['Name']; // Access CompanyName from CompanyDetails
        var ProfilePic = users[0]['CompanyDetails']['CompanyLogo']; // Access CompanyName from CompanyDetails
        var userAddress1 = users[0]['Address1'];
        var userAddress2 = users[0]['Address2'];
        var pincode = users[0]['Pincode'];
        var Mobile = users[0]['Mobile'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
        var ActiveUser = users[0]["Status"]

        var plan_end_date_m = moment(RegistrationDate).add(10, 'days').format('DD-MMM-YYYY');
        RegistrationDate = moment(RegistrationDate).format('DD-MMM-YYYY');
    }
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }

    useEffect(() => {
        if (Array.isArray(users) && users.length > 0) {
            if (ProfilePic !== '' && ProfilePic !== 'N/A') {
                setProfilepic(`${process.env.REACT_APP_API_URL}/api/user/uploads/${ProfilePic}`);
            }
            else {
                setProfilepic(noUser);
            }
        }
    }, [users, ProfilePic]);

    // console.log('planID' + planID);

    // useEffect(() => {
    //     if (Array.isArray(users) && users.length > 0) {
    //         if (ProfilePic !== '') {
    //             setProfilepic(`${process.env.REACT_APP_API_URL}/api/user/uploads/${ProfilePic}`);
    //         }
    //         else {
    //             setProfilepic(noUser);
    //         }
    //     }
    // }, [users]);

    // const [profilepic, setProfilepic] = useState('');

    const updateAvatar = async (file, imgSrc) => {
        // Validate the image file
        const validation = validateImageFile(file);
        if (!validation.valid) {
            showToast(validation.msg, 'error');
            return;
        }
        // Proceed with updating avatar if file is valid
        avatarUrl.current = imgSrc;
        setProfilepic(file);
        try {
            StartLoading(setisLoading, setisDisabled);
            const formData = new FormData();
            formData.append("userImage", file);


            UpdateUserProfileImage(formData, imgSrc)
        } catch (err) {
            showToast('Something went wrong! Please try again later', 'error');
            StopLoading(setisLoading, setisDisabled);
        } finally {
            StopLoading(setisLoading, setisDisabled);
        }
    };

    const UpdateUserProfileImage = async (formData, imgSrc) => {
        try {
            StartLoading(setisLoading, setisDisabled);
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/UpdateCompanyLogoImage`, formData, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading, setisDisabled);
                    showToast(res.data.message, 'success');
                    setProfilepic(imgSrc);
                })
                .catch((err) => {
                    showToast('Something went wrong! Please try again later', 'error');
                    StopLoading(setisLoading, setisDisabled);
                });
        } catch (err) {
            showToast('Something went wrong! Please try again later', 'error');
            StopLoading(setisLoading, setisDisabled);
        }
    };

    return (
        <div className='md:flex md:flex-row md:w-full'>
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={UserProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype?.toString()} currentUserType={type} />
                <div className="lg:w-full lg:flex lg:justify-between relative ">
                    <div className="w-full">
                        <div className=" px-4 my-2 text-xl font-bold text-[#1e3a8a]  ">
                            <div to="/categories/Category/" className="flex flex-row">
                                <FiHome className=" m-1" />
                                <h1 className="text-sm mt-1 text-blue-700"> Dashboard</h1>
                            </div>
                        </div>
                        <div className={`${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer') ? 'text-black' : 'text-black'} flex flex-col lg:flex-col xl:flex-row px-2 my-3 `}>
                            {isLoading ? <div className="animate-pulse bg-gray-200 rounded-xl p-3 w-full flex flex-row">
                                <div className="w-full">
                                    <div className="flex flex-row justify-between w-full">
                                        <div className="w-full">
                                            <div className="text-center my-2">
                                                <div className="flex flex-row justify-center my-2">
                                                    <div className="mr-2 bg-gray-100 h-7 w-7 rounded-md"></div>
                                                    <div className="font-semibold text-md bg-gray-100 h-4 w-1/2 rounded-md"></div>
                                                </div>
                                                <div className="font-semibold my-2 bg-gray-100 h-4 w-1/2 rounded-md"></div>
                                                <div className="text-md font-semibold m-0 p-0 py-2 bg-gray-100 h-4 w-3/4 rounded-md"></div>
                                            </div>
                                            <div className="w-full flex flex-row justify-between px-4 my-2 ">
                                                <div className="justify-center font-bold text-xl flex flex-row">
                                                    <div className="capitalize font-bold bg-gray-100 h-4 w-1/4 rounded-md"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-center">
                                            <div className="relative">
                                                <div className="w-32 h-32 rounded-full border-[#ffffff] border-2 bg-gray-100"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex flex-row justify-between px-4 mb-4">
                                        <div className="bg-gray-100 h-4 w-1/3 rounded-md"></div>
                                        <div className="bg-gray-100 h-4 w-1/3 rounded-md"></div>
                                        <div className="bg-gray-100 h-4 w-1/3 rounded-md"></div>
                                    </div>
                                    <div className="w-full flex flex-row justify-between px-4 my-4">
                                        <div className="bg-gray-100 h-4 w-1/3 rounded-md"></div>
                                        <div className="bg-gray-100 h-4 w-1/3 rounded-md"></div>
                                        <div className="bg-gray-100 h-4 w-1/3 rounded-md"></div>
                                    </div>
                                </div>
                            </div> :
                            //  
                                <div className="flex flex-col p-2 md:flex-row rounded-xl lg:p-3 w-full rounded-xl mr-2 p-1 border-[1px] border-solid bg-white w-full    flex flex-col p-1 md:flex-row rounded-xl lg:p-3 w-full">
                                    <div className={`${(hasOne && type === 'buyer') ? 'bg-gradient-to-b from-secondarygradiant to-secondarygradiant' : (hasOneAndTwo && type === 'seller') ? 'bg-gradient-to-b from-primarygradiant to-primarygradiant' : null} w-full`}>
                                        <div className="flex flex-row md:flex-row justify-between w-full md:mb-5">
                                            <div className="w-full">
                                                <div className="text-center my-2">
                                                    <div className="flex flex-row justify-center my-2">
                                                        <img className="mr-2" src={Indiacirclelogo} width={28} height={24} alt="Dashboard" />
                                                        <p className="font-semibold text-md lg:text-md">{CompanyName}</p>
                                                    </div>
                                                    <p className="font-semibold my-2 text-xs lg:text-md">
                                                        {userAddress1} {userAddress2} {pincode}
                                                    </p>
                                                    <p className={`${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer') ? 'bg-[#b3d0f7] !text-[#181d43]' : 'bg-[#c1efda] text-[#3a2600]'} text-md font-semibold m-0 p-0 py-2`}>
                                                        Application Code : {AppID}
                                                    </p>
                                                </div>
                                                <div className="w-full flex flex-row justify-between px-4 my-2">
                                                    <div className="justify-center font-bold text-xl flex flex-row">
                                                        <h6 className="capitalize font-bold">
                                                            Name : {username}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:flex md:justify-center mdg::justify-end mt-4 md:mt-0">
                                                <div className="relative">
                                                    <img
                                                        src={profilepic}
                                                        alt="Avatar"
                                                        className="w-[50px] lg:w-[150px] rounded-full border-[#ffffff] border-2"
                                                    />

                                                    {ActiveUser === 1 &&
                                                        <button
                                                            className="absolute -bottom-5 md:-bottom-3 left-0 right-0 m-auto w-fit p-[.35rem] rounded-full bg-white hover:bg-gray-200 border border-gray-200"
                                                            title="Change photo"
                                                            onClick={() => setModalOpen(true)}
                                                        >
                                                            <PencilIcon />
                                                        </button>
                                                    }
                                                </div>

                                                {modalOpen && (
                                                    <ProfilePicModal
                                                        updateAvatar={updateAvatar}
                                                        closeModal={() => setModalOpen(false)}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                        <div className="w-full flex flex-col md:flex-row justify-between px-4 mb-4">
                                            <div>
                                                <p className="text-sm py-2 m-0">Mobile Number</p>
                                                <h6 className="m-0 p-0 font-semibold">
                                                    +91 {Mobile}
                                                </h6>
                                            </div>
                                            <div>
                                                <p className="text-sm py-2 m-0">Email Address</p>
                                                <h6 className="m-0 p-0 font-semibold">
                                                    {EmailAddress}
                                                </h6>
                                            </div>
                                            <div>
                                                <p className="text-sm">Account Status</p>
                                                <div className="flex flex-row">
                                                    <svg className="mt-1 mr-1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                                                        <circle id="Ellipse_39" data-name="Ellipse 39" cx="6" cy="6" r="6" fill={ActiveUser === 1 ? "#4e9b00" : "#FF0000"} />
                                                    </svg>
                                                    <h6 className="text-xs font-bold">{ActiveUser ? "Active" : "In Active"}</h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="w-full flex flex-col md:flex-row justify-between px-4 my-4">
                                            <div>
                                                <p className="text-sm">Started Date</p>
                                                <h6 className="text-xs lg:text-md font-semibold pb-3">
                                                    {planDetails.startDate}
                                                </h6>
                                            </div>
                                            <div>
                                                <p className="text-sm">Plan Up to date</p>
                                                <h6 className="text-xs lg:text-md font-semibold pb-3">
                                                    {planDetails.endDate}
                                                </h6>
                                            </div>
                                            <div>
                                                <p className="text-sm">Account Type</p>
                                                <h6 className="text-xs lg:text-md font-semibold pb-3">  {planDetails.PlanName?.trim() ? planDetails.PlanName : "freemium"}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="rounded-xl mr-2 p-2 border-[1px] border-solid bg-white w-full">
                                <div className="flex flex-col md:flex-row">
                                    {/* Available Orders Section */}
                                    {/* <div className={`${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer') ? 'bg-gradient-to-b from-[#21a8ed] to-[#025883]' : hasOneAndTwo ? 'bg-gradient-to-b from-[#ffd938] to-[#FFAB23]' : null} w-full md:w-1/2 my-2 md:mx-2 p-2 rounded-xl`}>
                                        <div className="flex justify-between">
                                            <h1 className="font-bold text-sm">Available Orders</h1>
                                            <Tippy content={<span>SKU stands for Stock Keeping Unit, which is a unique identifier used in retail and manufacturing to keep track of inventory</span>}>
                                                <button className="mx-3"><FaInfo className="text-md text-black" /></button>
                                            </Tippy>
                                        </div>
                                        <div className="flex flex-col md:flex-row mt-2">
                                            <div className="w-full">
                                                <h1 className="font-bold text-5xl pl-4">{orders.RemainingOrders} / 25 </h1>
                                                <Link to="/seller/orders/View-Seller-orders/" className="text-sm mt-3">View all orders</Link>
                                            </div>
                                            <div className="w-1/2 md:w-full mt-2 md:mt-0">
                                                <BsCart3 className="text-8xl opacity-40 text-white" />
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className={`relative ${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer') ? 'bg-gradient-to-b from-secondarygradiant to-secondarygradiant'
                                        : hasOneAndTwo
                                            ? 'bg-gradient-to-b from-primarygradiant to-primarygradiant'
                                            : ''
                                        } w-full md:w-1/2 p-3 rounded-xl overflow-hidden mr-2`}
                                    >
                                        <div className="flex justify-between  relative">
                                            <h1 className="font-bold text-md">{type === "buyer" ? "Total orders" : "Available orders"}</h1>
                                            <Tippy content={<span>SKU stands for Stock Keeping Unit, which is a unique identifier used in retail and manufacturing to keep track of inventory</span>}>
                                                <button className="mx-3">
                                                    <FaInfo className="text-md md:text-lg text-black" />
                                                </button>
                                            </Tippy>
                                        </div>

                                        <div className="relative  text-left mt-8">
                                            <h1 className="font-bold text-2xl sm:text-5xl md:text-2xl mb-3">
                                                {type === "buyer" ? `${buyerOrders.totalOrders}` : `${orders.RemainingOrders}  / ${orders.totalPlansOrders}`}
                                            </h1>

                                            {type === "buyer" ? (
                                                <Link to={`/${type}/orders/View-${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()}-orders`} className="block text-xs sm:text-sm mt-2" >
                                                    View all orders
                                                </Link>
                                            ) : (
                                                <Link to={`/${type}/orders/View-${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()}-orders/Placed`} className="block text-xs sm:text-sm mt-2" >
                                                    View all orders
                                                </Link>
                                            )}
                                        </div>


                                        {/* /View- */}

                                        {/* Background Icon */}
                                        <div className="absolute right-2 bottom-2 opacity-20 text-white text-[10rem] pointer-events-none">
                                            <BsCart3 />
                                        </div>
                                    </div>



                                    {/* Users Section */}
                                    {/* <div className={`${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer') ? 'bg-gradient-to-b from-[#21a8ed] to-[#025883]' : hasOneAndTwo ? 'bg-gradient-to-b from-[#ffd938] to-[#FFAB23]' : null} w-full md:w-1/2 my-2 md:mx-2 p-2 rounded-xl`}>
                                        <div>
                                            <h1 className="font-bold text-sm">Users</h1>
                                        </div>
                                        <div className="flex flex-col md:flex-row mt-2">
                                            <div className="w-full">
                                                <h1 className="font-bold text-5xl pl-4">1/1</h1>
                                                <h1 className="text-sm mt-3">View More</h1>
                                            </div>
                                            <div className="w-1/2 md:w-full mt-2 md:mt-0">
                                                <TbUsers className="text-8xl opacity-40 text-white" />
                                            </div>
                                        </div>
                                    </div> */}
                                    <div
                                        className={`relative ${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer')
                                            ? 'bg-gradient-to-b from-secondarygradiant to-secondarygradiant'
                                            : hasOneAndTwo
                                                ? 'bg-gradient-to-b from-primarygradiant to-primarygradiant'
                                                : ''
                                            } w-full md:w-1/2  p-3 rounded-xl overflow-hidden`}
                                    >
                                        {/* Title */}
                                        <div className="relative ">
                                            <h1 className="font-bold text-md">Users</h1>
                                        </div>

                                        {/* User Count */}
                                        <div className="relative text-left mt-8">
                                            <h1 className="font-bold text-4xl sm:text-5xl md:text-4xl pb-3">{type === "buyer" ? "1/1" : `${orders.totalUsersCount - orders.usedUserCounts} / ${orders.totalUsersCount}`} </h1>
                                            <h1 className="text-xs sm:text-sm mt-2">View More</h1>
                                        </div>

                                        {/* Background Icon */}
                                        <div className="absolute inset-0 flex justify-center items-center opacity-20 text-white text-[12rem] pointer-events-none">
                                            <TbUsers />
                                        </div>
                                    </div>

                                </div>

                                <div className="flex flex-col md:flex-row ">
                                    {/* Distributors/Suppliers Section */}
                                    {/* <div className={`${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer') ? 'bg-gradient-to-b from-[#21a8ed] to-[#025883]' : hasOneAndTwo ? 'bg-gradient-to-b from-[#ffd938] to-[#FFAB23]' : null} w-full md:w-1/2 md:m-2 p-2 rounded-xl`}>
                                        <div>
                                            <h1 className="font-bold text-sm">
                                                {(hasOneAndTwo && type.toLowerCase() === 'seller') ? 'Distributors' :
                                                    (hasOne && type.toLowerCase() === 'buyer') ? 'Supplier' :
                                                        ((hasOne || hasOneAndTwo) && type.toLowerCase() === 'buyer') ? 'Supplier' :
                                                            ((hasOne) && type.toLowerCase() === 'seller') ? 'Supplier' : null}
                                            </h1>
                                        </div>
                                        <div className="flex flex-col md:flex-row mt-2">
                                            <div className="w-full">
                                                <h1 className="font-bold text-5xl pl-4">0</h1>
                                                <Link to={
                                                    (hasOneAndTwo && type.toLowerCase() === 'seller') ? '/seller/distributors/View-distributor/' :
                                                        (hasOne && type.toLowerCase() === 'buyer') ? 'Supplier' :
                                                            ((hasOne || hasOneAndTwo) && type.toLowerCase() === 'buyer') ? 'Supplier' :
                                                                ((hasOne) && type.toLowerCase() === 'seller') ? 'Supplier' : null
                                                } className="text-sm mt-3">All&nbsp;
                                                    {(hasOneAndTwo && type.toLowerCase() === 'seller') ? 'Distributors' :
                                                        (hasOne && type.toLowerCase() === 'buyer') ? 'Supplier' :
                                                            ((hasOne || hasOneAndTwo) && type.toLowerCase() === 'buyer') ? 'Supplier' :
                                                                ((hasOne) && type.toLowerCase() === 'seller') ? 'Supplier' : null}
                                                </Link>
                                            </div>
                                            <div className="w-1/2 md:w-full mt-2 md:mt-0">
                                                <FaUserTie className="text-8xl opacity-40 text-white" />
                                            </div>
                                        </div>
                                    </div> */}
                                    <div
                                        className={`relative ${(hasOne && type.toLowerCase() === 'buyer') || (hasOneAndTwo && type.toLowerCase() === 'buyer')
                                            ? 'bg-gradient-to-b from-secondarygradiant to-secondarygradiant'
                                            : hasOneAndTwo
                                                ? 'bg-gradient-to-b from-primarygradiant to-primarygradiant'
                                                : ''
                                            } w-full md:w-1/2 p-3 rounded-xl overflow-hidden md:mt-2 md:mr-2`}
                                    >
                                        {/* Dynamic Title */}
                                        <div className="relative">
                                            <h1 className="font-bold text-md md:text-base lg:text-lg">
                                                {
                                                    (hasOneAndTwo && type.toLowerCase() === 'seller') ? 'Distributors' :
                                                        'Supplier'
                                                }
                                            </h1>
                                        </div>

                                        {/* Count & Link */}
                                        <div className="relative text-left mt-8">

                                            <h1 className="font-bold text-4xl sm:text-5xl md:text-4xl pb-3">  {type === "buyer" ? `${buyerOrders.totalSupplier}` : `${orders.toatlDistributors}`}</h1>
                                            <Link
                                                to={
                                                    (hasOneAndTwo && type.toLowerCase() === 'seller') ? '/seller/distributors/View-distributor/' :
                                                        '/buyer/suppliers/View-all-suppliers/'
                                                }
                                                className="block text-xs sm:text-sm"
                                            >
                                                All&nbsp;
                                                {
                                                    (hasOneAndTwo && type.toLowerCase() === 'seller') ? 'Distributors' :
                                                        'Supplier'
                                                }
                                            </Link>
                                        </div>

                                        {/* Background Icon */}
                                        <div className="absolute inset-0 flex justify-center items-center opacity-20 text-white text-[12rem] pointer-events-none">
                                            <FaUserTie />
                                        </div>
                                    </div>


                                    {/* Pending Request Section */}
                                    {/* <div className={`${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer') ? 'bg-gradient-to-b from-[#21a8ed] to-[#025883]' : hasOneAndTwo ? 'bg-gradient-to-b from-[#ffd938] to-[#FFAB23]' : null} w-full md:w-1/2 my-2 md:mx-2 p-2 rounded-xl`}>
                                        <div>
                                            <h1 className="font-bold text-sm">Pending Request</h1>
                                        </div>
                                        <div className="flex flex-col md:flex-row mt-2">
                                            <div className="w-full">
                                                <h1 className="font-bold text-5xl pl-4">
                                                    {orders.DistributorRequest}
                                                </h1>
                                                <Link to="/seller/distributors/View-distributors-request/" className="text-sm mt-3">View All Request</Link>
                                            </div>
                                            <div className="w-1/2 md:w-full mt-2 md:mt-0">
                                                <BiMessageAltError className="text-8xl opacity-40 text-white" />
                                            </div>
                                        </div>
                                    </div> */}
                                    <div
                                        className={`relative ${(hasOne && type === 'buyer') || (hasOneAndTwo && type === 'buyer')
                                            ? 'bg-gradient-to-b from-secondarygradiant to-secondarygradiant'
                                            : hasOneAndTwo
                                                ? 'bg-gradient-to-b from-primarygradiant to-primarygradiant'
                                                : ''
                                            } w-full md:w-1/2  p-3 rounded-xl overflow-hidden md:mt-2`}
                                    >
                                        {/* Title */}
                                        <div className="relative">
                                            <h1 className="font-bold text-md md:text-base lg:text-lg">Pending requests</h1>
                                        </div>

                                        {/* Count & Link */}
                                        <div className="relative text-left mt-8">
                                            <h1 className="font-bold text-4xl sm:text-5xl md:text-4xl mb-3">

                                                {type === "buyer" ? `${buyerOrders.supplierRequest}` : `${orders.DistributorRequest}`}

                                            </h1>
                                            <Link
                                                // to="/seller/distributors/View-distributors-request/"
                                                className="block text-xs sm:text-sm mt-2"
                                            >
                                                View All Request
                                            </Link>
                                        </div>

                                        {/* Background Icon */}
                                        <div className="absolute inset-0 flex justify-center items-center opacity-20 text-white text-[12rem] pointer-events-none">
                                            <BiMessageAltError />
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className=" h-50 rounded-xl m-1 bg-white border-[1px] border-solid w-full">
                                <OrdersPieChart />
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" flex flex-row px-2">
                    <div className="flex w-full flex-col lg:flex-row rounded-xl p-1 shadow-[0px_10px_36px_0px_rgba(0,0,0,0.16),0px_0px_0px_1px_rgba(0,0,0,0.06)]">
                        <div className="h-auto lg:h-32 w-full lg:w-1/4 my-2 mx-2 p-2 rounded-xl bg-gradient-to-b from-[#0097E5] to-[#004C73] ">
                            <div>
                                <h1 className="font-bold text-sm text-white"> New Orders </h1>
                            </div>
                            <div className="flex flex-row mt-2 justify-end relative">
                                <div className="w-full ">
                                    <h1 className="font-bold text-5xl pl-4 text-white">

                                        {type === "buyer" ? `${buyerOrders.Newordersrs}` : `${orders.Newordersrs}`}


                                    </h1>
                                    <Link to={`${(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? "/seller/orders/View-Seller-orders/Placed" : "/buyer/orders/View-Buyer-orders/"}`}>
                                        <h1 className="text-sm mt-3 text-white">
                                            View {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? 'New' : 'All'} orders
                                        </h1>
                                    </Link>
                                </div>
                                <div className=" absolute opacity-20 lg:opacity-80 right-0 ">
                                    <BsCart3 className="text-8xl opacity-40 text-white" />
                                </div>
                            </div>
                        </div>
                        <div className="h-auto lg:h-32 w-full lg:w-1/4 my-2 md:mx-2 p-2 rounded-xl bg-gradient-to-b from-[#4DD500] to-[#236101] ">
                            <div>
                                <h1 className="font-bold text-sm text-white">
                                    Confirmed Orders{" "}
                                </h1>
                            </div>
                            <div className="flex flex-row mt-2 justify-end relative">
                                <div className="w-full ">
                                    <h1 className="font-bold text-5xl pl-4 text-white">

                                        {type === "buyer" ? `${buyerOrders.Confirmorders}` : `${orders.Confirmorders}`}

                                    </h1>
                                    <Link to={`${(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? "/seller/orders/View-Seller-orders/Confirmed" : "/buyer/orders/View-Buyer-orders/"}`}>
                                        <h1 className="text-sm mt-3 text-white">
                                            View  {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? 'Confirmed' : 'All'}  orders
                                        </h1>
                                    </Link>

                                </div>
                                <div className=" absolute opacity-20 lg:opacity-80 right-0">
                                    <BsCart3 className="text-8xl opacity-40 text-white" />
                                </div>
                            </div>
                        </div>
                        <div className="h-auto lg:h-32 w-full lg:w-1/4 my-2 md:mx-2 p-2 rounded-xl bg-gradient-to-b from-[#FF9306] to-[#A45E02] ">
                            <div>
                                <h1 className="font-bold text-sm text-white">
                                    Orders On Hold
                                </h1>
                            </div>
                            <div className="flex flex-row mt-2 justify-end relative">
                                <div className="w-full ">
                                    <h1 className="font-bold text-5xl pl-4 text-white">

                                        {type === "buyer" ? `${buyerOrders.Onholdorders}` : `${orders.Onholdorders}`}

                                    </h1>
                                    <Link to={`${(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? "/seller/orders/View-Seller-orders/OnHold" : "/buyer/orders/View-Buyer-orders/"}`}>

                                        <h1 className="text-sm mt-3 text-white">
                                            View  {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? 'On Hold' : 'All'}  orders
                                        </h1>
                                    </Link>
                                </div>
                                <div className=" absolute opacity-20 lg:opacity-80 right-0">
                                    <BsCart3 className="text-8xl opacity-40 text-white" />
                                </div>
                            </div>
                        </div>
                        <div className="h-auto lg:h-32 w-full lg:w-1/4 my-2 md:mx-2 p-2 rounded-xl bg-gradient-to-b from-[#76C280] to-[#04480D] ">
                            <div>
                                <h1 className="font-bold text-sm text-white">
                                    Orders Processing
                                </h1>
                            </div>
                            <div className="flex flex-row mt-2 justify-end relative">
                                <div className="w-full ">
                                    <h1 className="font-bold text-5xl pl-4 text-white">

                                        {type === "buyer" ? `${buyerOrders.Onprocessorders}` : `${orders.Onprocessorders}`}

                                    </h1>
                                    <Link to={`${(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? "/seller/orders/View-Seller-orders/Processing" : "/buyer/orders/View-Buyer-orders/"}`}>

                                        <h1 className="text-sm mt-3 text-white">
                                            View  {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? 'Processing' : 'All'}  orders
                                        </h1>
                                    </Link>
                                </div>
                                <div className=" absolute opacity-20 lg:opacity-80 right-0">
                                    <BsCart3 className="text-8xl opacity-40 text-white" />
                                </div>
                            </div>
                        </div>
                        <div className="h-auto lg:h-32 w-full lg:w-1/4 my-2 mx-2 p-2 rounded-xl bg-gradient-to-b from-[#59F8AD] to-[#02502B] ">
                            <div>
                                <h1 className="font-bold text-sm text-white">
                                    Completed Orders
                                </h1>
                            </div>
                            <div className="flex flex-row mt-2 justify-end relative">
                                <div className="w-full ">
                                    <h1 className="font-bold text-5xl pl-4 text-white">

                                        {type === "buyer" ? `${buyerOrders.Completedorders}` : `${orders.Completedorders}`}

                                    </h1>
                                    <Link to={`${(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? "/seller/orders/View-Seller-orders/Completed" : "/buyer/orders/View-Buyer-orders/"}`}>

                                        <h1 className="text-sm mt-3 text-white">
                                            View  {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? 'Completed' : 'All'}   orders
                                        </h1>
                                    </Link>
                                </div>
                                <div className=" absolute opacity-20 lg:opacity-80 right-0">
                                    <BsCart3 className="text-8xl opacity-40 text-white" />
                                </div>
                            </div>
                        </div>
                        <div className="h-auto lg:h-32 w-full lg:w-1/4 my-2 mx-2 p-2 rounded-xl bg-gradient-to-b from-[#F93932] to-[#8A1300] ">
                            <div>
                                <h1 className="font-bold text-sm text-white">
                                    Delivered Orders
                                </h1>
                            </div>
                            <div className="flex flex-row mt-2 justify-end relative">
                                <div className="w-full ">
                                    <h1 className="font-bold text-5xl pl-4 text-white">

                                        {type === "buyer" ? `${buyerOrders.Cancelledorders}` : `${orders.Cancelledorders}`}

                                    </h1>
                                    <Link to={`${(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? "/seller/orders/View-Seller-orders/Cancelled" : "/buyer/orders/View-Buyer-orders/"}`}>
                                        <h1 className="text-sm mt-3 text-white">
                                            View {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? 'Delivered' : 'All'}   orders
                                        </h1>
                                    </Link>
                                </div>
                                <div className=" absolute opacity-20 lg:opacity-80 right-0">
                                    <BsCart3 className="text-8xl opacity-40 text-white" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <OrdersChart />
                <div className=" flex flex-col lg:flex-row p-4">
                    {/* <div className="rounded-xl p-3  shadow-[0px_10px_36px_0px_rgba(0,0,0,0.16),0px_0px_0px_1px_rgba(0,0,0,0.06)]">
                        <div className="flex flex-col lg:flex-auto m-2">
                            <div className="w-full lg:w-1/2 justify-start flex flex-row">
                                <h1 className=" w-full mt-3 pt-1 text-font-color text-sm font-bold">
                                    Account Configuration
                                </h1>
                                <ProgressBar
                                    className="m-1  w-1/4"
                                    bgcolor="orange"
                                    progress="80"
                                    height={18}
                                />
                            </div>
                            <div className="flex flex-col lg:flex-row w-full justify-start">
                                <div className="m-3 pr-3  flex flex-row text-font-color">
                                    <img
                                        className="mr-2"
                                        src={Check}
                                        width={15}
                                        height={15}
                                        alt="Dasahboard"
                                    />{" "}
                                    seller setup
                                </div>
                                <div className="m-3 px-3 flex flex-row text-font-color">
                                    <img
                                        className="mr-2"
                                        src={Check}
                                        width={15}
                                        height={15}
                                        alt="Dasahboard"
                                    />{" "}
                                    Invite buyers{" "}
                                </div>
                                <div className="m-3 px-3 flex flex-row text-font-color">
                                    <img
                                        className="mr-2"
                                        src={Check}
                                        width={15}
                                        height={15}
                                        alt="Dasahboard"
                                    />{" "}
                                    Update Profile
                                </div>
                                <div className="m-3 pl-3 flex flex-row text-font-color">
                                    <img
                                        className="mr-2"
                                        src={Check}
                                        width={15}
                                        height={15}
                                        alt="Dasahboard"
                                    />{" "}
                                    Data Publish
                                </div>
                            </div>
                        </div>
                        <div className="m-3">
                            {" "}
                            <p className="text-sm font-bold text-font-color">
                                The First Step is to set up your company information and
                                seller information to place your seller position with other
                                seller on Selzor platform !{" "}
                            </p>
                        </div>
                    </div> */}
                    <div className="flex lg:w-1/3 flex-col rounded-xl m-3 p-4 shadow-[0px_10px_36px_0px_rgba(0,0,0,0.16),0px_0px_0px_1px_rgba(0,0,0,0.06)]">
                        <h6 className="text-md text-font-color font-bold">
                            {" "}
                            Having Trouble ?
                        </h6>
                        <p className="text-md mt-2 m-0 p-0">
                            {" "}
                            Watch a Instructions video how to use our platform and work with
                            us ?
                        </p>
                        <div className="flex flex-row ">
                            <h6 className="text-md font-bold underline mt-2 pb-2 text-font-color">
                                {" "}
                                View More{" "}
                            </h6>
                            <BsArrowRightShort className="m-3" />
                        </div>
                    </div>
                    <div className="flex lg:w-1/3 flex-col rounded-xl m-3 p-4 shadow-[0px_10px_36px_0px_rgba(0,0,0,0.16),0px_0px_0px_1px_rgba(0,0,0,0.06)]">
                        <h6 className="text-md text-font-color font-bold">
                            {" "}
                            Need Help?
                        </h6>
                        <p className="text-md mt-2 m-0 p-0">
                            {" "}
                            Chat with us or call us on number +91 9632587410
                        </p>
                        <div className="flex flex-row ">
                            <h6 className="text-md font-bold underline mt-2 pb-2 text-font-color">
                                {" "}
                                View More{" "}
                            </h6>
                            <BsArrowRightShort className="m-3" />
                        </div>
                    </div>
                    <div className="flex lg:w-1/3 flex-col rounded-xl m-3 p-4 shadow-[0px_10px_36px_0px_rgba(0,0,0,0.16),0px_0px_0px_1px_rgba(0,0,0,0.06)]">
                        <h6 className="text-md text-font-color font-bold">
                            {" "}
                            Documentation
                        </h6>
                        <p className="text-md mt-2 m-0 p-0">
                            {" "}
                            Need to watch a Instructions Documetation how to use our platform and work with
                            us ?
                        </p>
                        <div className="flex flex-row ">
                            <h6 className="text-md font-bold underline mt-2 pb-2 text-font-color">
                                {" "}
                                View More{" "}
                            </h6>
                            <BsArrowRightShort className="m-3" />
                        </div>
                    </div>
                </div>

            </div>
            {isLoading && (
                <div style={overlayStyle}>
                    <div style={loaderStyle}>Loading...</div>
                </div>
            )}
        </div>
    )
}

export default Dashboard